module.exports = __webpack_public_path__ + "6603614dc8852b25c6dfcead08d189d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_logout.png
// module id = 49
// module chunks = 0 1 2 3 4